<template>
    <div class="container">
        <vue-headful
                title="Website Settings - SIC Dashboard"
        />
        <div class="row">
            <div class="col-md-12 mt-5 mb-2">
                <div class="card shadow">
                    <div class="card-header border-0">
                        <h3 class="mb-0">Website Settings</h3>
                    </div>
                    <div class="card-body">
                        <form role="form">
                            <div class="form-group mb-3">
                                <label>Idea Brief</label>
                                <editor v-model="ideaBrief" v-validate="'required|min:16'" name="idea-brief"
                                        api-key="API_KEY" :init="{plugins: 'wordcount'}"
                                        data-vv-as="Idea Brief"></editor>
                                <small v-if="errors.has('idea-brief')" class="text-danger">
                                    {{ errors.first('idea-brief') }}
                                </small>
                            </div>
                            <div class="form-row">
                                <div class="form-group col mb-3">
                                    <label>Idea Start Date</label>
                                    <input v-model="ideaBriefDates.start_date" type="date" class="form-control" placeholder="Idea Start Date">
                                </div>
                                <div class="form-group col mb-3">
                                    <label>Idea End Date</label>
                                    <input v-model="ideaBriefDates.end_date" type="date" class="form-control" placeholder="Idea End Date">
                                </div>
                            </div>
                            <div class="">
                                <button @click="updateIdeaBrief" type="button" class="btn my-4 btn-primary">
                                    <i :class="{'loader': ideaLoading}"></i> {{briefButton}}
                                </button>
                            </div>
                        </form>
                        <hr class="my-3">
                        <form role="form">
                            <div class="form-group mb-3">
                                <label>Meeting Rooms</label>
                                <div class="table-responsive">
                                    <table class="table align-items-center table-flush">
                                        <thead class="thead-light">
                                        <tr>
                                            <th scope="col">Room Type</th>
                                            <th scope="col">1 Hour Pricing</th>
                                            <th scope="col">3 Hour Pricing</th>
                                            <th scope="col">24 Hour Pricing</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(room, index ) in meetingRooms" :key="room.type">
                                            <th>{{room.name}}</th>
                                            <td><input v-model="meetingRooms[index].one" type="number" class="form-control"/></td>
                                            <td><input v-model="meetingRooms[index].three" type="number" class="form-control"/></td>
                                            <td><input v-model="meetingRooms[index].twoFour" type="number" class="form-control"/></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="">
                                <button @click="updateMeetingRooms" type="button" class="btn my-4 btn-primary">
                                    <i :class="{'loader': meetingLoading}"></i> {{meetingButton}}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import vueHeadful from "vue-headful";
import Editor from "@tinymce/tinymce-vue";
import _ from "lodash";

export default {
  data() {
    return {
      meetingLoading: false,
      ideaLoading: false,
      ideaBrief: "",
      ideaBriefDates: {},
      briefButton: "Save",
      meetingRooms: {},
      meetingButton: "Save"
    };
  },
  mounted() {
    this.getIdeaBrief();
    this.getMeetingRooms();
  },
  methods: {
    getIdeaBrief() {
      axios({
        method: "get",
        url:
          "admin/website/idea-brief?access_token=" +
          localStorage.getItem("access_token"),
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.ideaBrief = result.data.idea_brief.value;
            this.ideaBriefDates = JSON.parse(
              result.data.idea_brief_dates.value
            );
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e.response);
        });
    },
    updateIdeaBrief() {
      this.$validator
        .validateAll()
        .then(result => {
          if (!result) {
            return;
          }

          this.briefButton = "";
          this.ideaLoading = true;
          axios({
            method: "post",
            url: "admin/website/idea-brief",
            data: {
              access_token: localStorage.getItem("access_token"),
              idea_brief: this.ideaBrief,
              idea_brief_dates: this.ideaBriefDates
            },
            headers: {
              "Content-Type": "application/json"
            }
          })
            .then(
              result => {
                this.$swal("Idea Brief Saved", "", "success");
                this.$validator.reset();
                this.ideaLoading = false;
                this.briefButton = "Save";
                this.ideaBrief = result.data.idea_brief.value;
              },
              error => {
                this.ideaLoading = false;
                this.briefButton = "Save";
                console.log(error);
                let errors = error.response.data.error;
                for (let error in errors) {
                  this.$noty.error("Error: " + _.startCase(errors[error][0]));
                }
              }
            )
            .catch(e => {
              this.ideaLoading = false;
              this.briefButton = "Save";
              console.log(e);
            });
        })
        .catch(e => {
          console.log(e.response);
        });
    },
    getMeetingRooms() {
      axios({
        method: "get",
        url:
          "admin/website/meeting-rooms?access_token=" +
          localStorage.getItem("access_token"),
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.meetingRooms = JSON.parse(result.data.meeting_rooms.value);
            // console.log(this.meetingRooms);
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    updateMeetingRooms() {
      console.log(this.meetingRooms);
      this.meetingButton = "";
      this.meetingLoading = true;
      axios({
        method: "post",
        url: "admin/website/meeting-rooms",
        data: {
          access_token: localStorage.getItem("access_token"),
          meeting_rooms: this.meetingRooms
        },
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.$swal("Meeting Rooms Prices Updated", "", "success");
            this.$validator.reset();
            console.log(result);
            this.meetingLoading = false;
            this.meetingButton = "Save";
            this.getMeetingRooms();
          },
          error => {
            this.meetingLoading = false;
            this.meetingButton = "Save";
            let errors = error.response.data.error;
            for (let error in errors) {
              this.$noty.error("Error: " + _.startCase(errors[error][0]));
            }
          }
        )
        .catch(e => {
          this.meetingLoading = false;
          this.meetingButton = "Save";
          console.log(e.response);
        });
    }
  },
  computed: {
    isComplete() {
      return this.ideaBrief;
    }
  },
  components: {
    "vue-headful": vueHeadful,
    editor: Editor
  }
};
</script>
<style>
</style>
